import { Injectable, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

import { DatabaseCacheService } from '@app/data/cache/database-cache.service';
import { StoreAuthService } from './store-auth.service';
import { StoreUserService } from '@app/core/state/store-user.service';
import { getRedirectUri } from '../../utils';

@Injectable({
  providedIn: 'root'
})
export class LogoutService {
  private readonly msalService = inject(MsalService);
  private readonly databaseCache = inject(DatabaseCacheService);
  private readonly storeAuth = inject(StoreAuthService);
  private readonly storeUser = inject(StoreUserService);

  /** 認証キャッシュ・インメモリ状態をクリアし、MSALログアウトリダイレクトを開始する。 */
  logout(): void {
    this.storeUser.setSelectedUser(null);
    this.storeUser.setLoadedUserRecords(null);
    this.storeAuth.setIsLoggedIn(false);
    this.storeAuth.setLoginUserName('');
    this.databaseCache.clearAuthCache();

    this.msalService.logoutRedirect({ postLogoutRedirectUri: getRedirectUri() })
      .subscribe({
        error: (error) => console.error('[LogoutService] logoutRedirect failed:', error)
      });
  }
}
